import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/chart/bar";
import "echarts/lib/component/legend";
import "echarts/lib/component/dataset";
import "echarts/lib/component/grid";

const BarChart = ({ data, title }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    const chart = echarts.init(chartRef.current);

    const option = {
      title: { text: title },
      legend: {},
      tooltip: {},
      dataset: {
        source: data,
      },
      xAxis: [
        { type: "category", gridIndex: 0 },
        { type: "category", gridIndex: 1 },
      ],
      yAxis: [{ gridIndex: 0 }, { gridIndex: 1 }],
      grid: [{ bottom: "55%" }, { top: "55%" }],
      series: [
        // These series are in the first grid.
        { type: "bar", seriesLayoutBy: "row" },
        { type: "bar", seriesLayoutBy: "row" },
        { type: "bar", seriesLayoutBy: "row" },
        // These series are in the second grid.
        { type: "bar", xAxisIndex: 1, yAxisIndex: 1 },
        { type: "bar", xAxisIndex: 1, yAxisIndex: 1 },
        { type: "bar", xAxisIndex: 1, yAxisIndex: 1 },
        { type: "bar", xAxisIndex: 1, yAxisIndex: 1 },
      ],
    };

    chart.setOption(option);

    const handleResize = () => chart.resize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      chart.dispose();
    };
  }, [data, title]);

  return <div ref={chartRef} style={{ width: "800px", height: "600px" }} />;
};

export default BarChart;
